import { NgModule } from '@angular/core';

import { NgxInactivityDirective } from './ngx-inactivity.directive';

@NgModule({
  declarations: [
    NgxInactivityDirective
  ],
  exports: [
    NgxInactivityDirective
  ]
})
export class NgxInactivity {
}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/~/ngx-inactivity/src/app/ngx-inactivity/ngx-inactivity.module.ts